import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=313e64b5&"
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313e64b5')) {
      api.createRecord('313e64b5', component.options)
    } else {
      api.reload('313e64b5', component.options)
    }
    module.hot.accept("./collection.vue?vue&type=template&id=313e64b5&", function () {
      api.rerender('313e64b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/collection.vue"
export default component.exports